import { GET_ALL_BRANDS, BRANDS_ERROR, BRANDS_LOADING } from "../ActionTypes";

const initialState = {
  brands: [],
  loading: false,
  error: {},
};

const BrandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_BRANDS:
      return {
        ...state,
        loading: false,
        brands: action.payload,
      };
    case BRANDS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case BRANDS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default BrandsReducer;
